module.exports = __webpack_public_path__ + "img/question.20d8bfdd.jpg";